import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _defineMessages;

import { defineMessages } from "@formatjs/intl";
export default defineMessages((_defineMessages = {
  addNewQuestionGrid: {
    id: "questionbank.questions.addNewQuestionGrid",
    defaultMessage: "Add New Question"
  },
  selectTagsPlaceholder: {
    id: "questionbank.questions.selectTagsPlaceholder",
    defaultMessage: "Select Tags"
  },
  statementPlaceholder: {
    id: "questionbank.questions.statementPlaceholder",
    defaultMessage: "Statement"
  },
  choicePlaceholder: {
    id: "questionbank.questions.choicePlaceholder",
    defaultMessage: "Choice"
  },
  createNewTagTypography: {
    id: "questionbank.questions.createNewTagTypography",
    defaultMessage: "Create new tag"
  },
  questionTypeLabel: {
    id: "questionbank.questions.questionTypeLabel",
    defaultMessage: "Question Type"
  },
  selectCourseTypography: {
    id: "questionbank.questions.selectCourseTypography",
    defaultMessage: "Select Course"
  },
  selectQuestionDiffTypography: {
    id: "questionbank.questions.selectQuestionDiffTypography",
    defaultMessage: " Select question difficulty"
  },
  modelAnswerTypography: {
    id: "questionbank.questions.modelAnswerTypography",
    defaultMessage: "Model Answer"
  },
  insertQuestionAnswersTypography: {
    id: "questionbank.questions.insertQuestionAnswersTypography",
    defaultMessage: "Insert question answers with minimum"
  },
  selectCorrectOnesTypography: {
    id: "questionbank.questions.selectCorrectOnesTypography",
    defaultMessage: "choices, then select the correct ones"
  },
  multipleChoicesTypography: {
    id: "questionbank.questions.multipleChoicesTypography",
    defaultMessage: "Multiple Choices"
  },
  strictModeTypography: {
    id: "questionbank.questions.strictModeTypography",
    defaultMessage: "Strict mode"
  },
  shuffleAnswersTypography: {
    id: "questionbank.questions.shuffleAnswersTypography",
    defaultMessage: "Shuffle Answers"
  },
  newOptionPlaceholder: {
    id: "questionbank.questions.newOptionPlaceholder",
    defaultMessage: "New Option"
  },
  addNewChoiceTypography: {
    id: "questionbank.questions.addNewChoiceTypography",
    defaultMessage: "Add New Choice"
  },
  addNewMatchingPair: {
    id: "questionbank.questions.addNewMatchingPair",
    defaultMessage: "Add New Matching Pair"
  },
  addNewDistractorChoice: {
    id: "questionbank.questions.addNewDistractorChoice",
    defaultMessage: "Add New Distractor Choice"
  },
  requireJustificationTypography: {
    id: "questionbank.questions.requireJustificationTypography",
    defaultMessage: "Require Justification"
  },
  fillRequiredToast: {
    id: "questionbank.questions.fillRequiredToast",
    defaultMessage: "Please fill the required fields correctly"
  },
  justificationTypography: {
    id: "questionbank.questions.justificationTypography",
    defaultMessage: "Justification"
  },
  blanksTypography: {
    id: "questionbank.questions.blanksTypography",
    defaultMessage: "Blanks"
  },
  fillBlanksTypography: {
    id: "questionbank.questions.fillBlanksTypography",
    defaultMessage: "Please fill the blanks with the correct answer in order"
  },
  caseSensitiveTypography: {
    id: "questionbank.questions.caseSensitiveTypography",
    defaultMessage: "Case Sensitive"
  },
  optionsTypography: {
    id: "questionbank.questions.optionsTypography",
    defaultMessage: "Options"
  },
  attachmentsLimitLabel: {
    id: "questionbank.questions.attachmentsLimitLabel",
    defaultMessage: "Attachments Limit"
  },
  characterLimitLabel: {
    id: "questionbank.questions.characterLimitLabel",
    defaultMessage: "Character Limit"
  },
  wordLimitLabel: {
    id: "questionbank.questions.wordLimitLabel",
    defaultMessage: "Word Limit"
  },
  noLimitLabel: {
    id: "questionbank.questions.noLimitLabel",
    defaultMessage: "No limit"
  },
  trueLabel: {
    id: "questionbank.questions.trueLabel",
    defaultMessage: "True"
  },
  falseLabel: {
    id: "questionbank.questions.falseLabel",
    defaultMessage: "False"
  },
  addButton: {
    id: "questionbank.questions.addButton",
    defaultMessage: "ADD"
  },
  previewButton: {
    id: "questionbank.questions.previewButton",
    defaultMessage: "PREVIEW"
  },
  cancelButton: {
    id: "questionbank.questions.cancelButton",
    defaultMessage: "CANCEL"
  },
  updateButton: {
    id: "questionbank.questions.updateButton",
    defaultMessage: "UPDATE"
  },
  answerTypography: {
    id: "questionbank.questions.answerTypography",
    defaultMessage: "Answer"
  },
  questionTypography: {
    id: "questionbank.questions.questionTypography",
    defaultMessage: "Question"
  },
  createNewTypography: {
    id: "questionbank.questions.createNewTypography",
    defaultMessage: "Create new"
  },
  wordsLimitSmallLabel: {
    id: "questionbank.questions.wordsLimitSmallLabel",
    defaultMessage: "words"
  },
  charsLimitSmallLabel: {
    id: "questionbank.questions.charsLimitSmallLabel",
    defaultMessage: "characters"
  },
  blankLabel: {
    id: "questionbank.questions.blankLabel",
    defaultMessage: "Blank"
  }
}, _defineProperty(_defineMessages, "blanksTypography", {
  id: "questionbank.questions.blanksTypography",
  defaultMessage: "Blanks"
}), _defineProperty(_defineMessages, "mcqLabelID", {
  id: "questionbank.questions.mcqLabelID",
  defaultMessage: "Multiple Choice (MCQ)"
}), _defineProperty(_defineMessages, "tfLabelID", {
  id: "questionbank.questions.tfLabelID",
  defaultMessage: "True or False (TF)"
}), _defineProperty(_defineMessages, "fibLabelID", {
  id: "questionbank.questions.fibLabelID",
  defaultMessage: "Fill in the Blank (FIB)"
}), _defineProperty(_defineMessages, "essayLabelID", {
  id: "questionbank.questions.essayLabelID",
  defaultMessage: "Essay"
}), _defineProperty(_defineMessages, "orderingLabelID", {
  id: "questionbank.questions.orderingLabelID",
  defaultMessage: "Order"
}), _defineProperty(_defineMessages, "matchingLabelID", {
  id: "questionbank.questions.matchingLabelID",
  defaultMessage: "Matching"
}), _defineProperty(_defineMessages, "fieldRequiredError", {
  id: "questionbank.questions.fieldRequiredError",
  defaultMessage: "This field is required"
}), _defineProperty(_defineMessages, "correctAnswerError", {
  id: "questionbank.questions.correctAnswerError",
  defaultMessage: "You must select a correct answer"
}), _defineProperty(_defineMessages, "mustHaveAtLeastError", {
  id: "questionbank.questions.mustHaveAtLeastError",
  defaultMessage: "You must have at least"
}), _defineProperty(_defineMessages, "choicesError", {
  id: "questionbank.questions.choicesError",
  defaultMessage: "choices"
}), _defineProperty(_defineMessages, "choicesExceedError", {
  id: "questionbank.questions.choicesExceedError",
  defaultMessage: "Choices shouldn't exceed"
}), _defineProperty(_defineMessages, "matchingPairsError", {
  id: "questionbank.questions.matchingPairsError",
  defaultMessage: "matching pairs"
}), _defineProperty(_defineMessages, "stamentCantEmptyError", {
  id: "questionbank.questions.stamentCantEmptyError",
  defaultMessage: "The question statement can't be empty"
}), _defineProperty(_defineMessages, "statmentAtLeastError", {
  id: "questionbank.questions.statmentAtLeastError",
  defaultMessage: "The question statement should be at least"
}), _defineProperty(_defineMessages, "lettersLengthError", {
  id: "questionbank.questions.lettersLengthError",
  defaultMessage: "letters length"
}), _defineProperty(_defineMessages, "limitMinimumValueWordError", {
  id: "questionbank.questions.limitMinimumValueWordError",
  defaultMessage: "Limit has minimum value of one word"
}), _defineProperty(_defineMessages, "limitMinimumValueCharsError", {
  id: "questionbank.questions.limitMinimumValueCharsError",
  defaultMessage: "Limit has minimum value of one character"
}), _defineProperty(_defineMessages, "provideModelAnswerError", {
  id: "questionbank.questions.provideModelAnswerError",
  defaultMessage: "You must provide a model answer"
}), _defineProperty(_defineMessages, "justificationWordError", {
  id: "questionbank.questions.justificationWordError",
  defaultMessage: "justification does not match word limits"
}), _defineProperty(_defineMessages, "blankError", {
  id: "questionbank.questions.blankError",
  defaultMessage: "blank"
}), _defineProperty(_defineMessages, "questionContainAtleastError", {
  id: "questionbank.questions.questionContainAtleastError",
  defaultMessage: "Question must contain at least"
}), _defineProperty(_defineMessages, "answerAtLeastError", {
  id: "questionbank.questions.answerAtLeastError",
  defaultMessage: "The answer should be at least"
}), _defineProperty(_defineMessages, "minimumValueZeroError", {
  id: "questionbank.questions.minimumValueZeroError",
  defaultMessage: "Limit has minimum value of zero"
}), _defineMessages));